/**
 * Dark-mode toggle (Wave 6 §7.3). Persisted to localStorage; the `dark`
 * class on <html> drives the Tailwind `darkMode: 'class'` token swap in
 * index.css. `color-scheme` follows along so native widgets (date/time
 * pickers, scrollbars) match.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeState = {
  dark: boolean;
  toggle: () => void;
};

function apply_theme(dark: boolean) {
  document.documentElement.classList.toggle('dark', dark);
}

export const use_theme_store = create<ThemeState>()(
  persist(
    (set, get) => ({
      dark: false,
      toggle: () => {
        const next = !get().dark;
        apply_theme(next);
        set({ dark: next });
      },
    }),
    {
      name: 'pet-marketplace-vendor-console-theme',
      onRehydrateStorage: () => (state) => {
        // Re-apply the persisted choice on page load.
        if (state) apply_theme(state.dark);
      },
    },
  ),
);
